export const darkTheme = {
    bg:"#1C1C27",
    bgLight: "#1C1E27",
    primary:"#854CE6",
    text_primary:"#F2F3F4",
    text_secondary:"#b1b2b3",
    card:"#171721",
    card_light: '#191924',
    button:"#854CE6",
    white:"#FFFFFF",
    black:"#000000",
}

export const lightTheme = {
    bg:"#FFFFFF",
    bgLight: "#000000",
    primary:"#be1adb",
    text_primary:"#000000",
    text_secondary:"#48494a",
    card:"#FFFFFF",
    card_light: '#f0f0f0', // lighter gray color
    button:"#5c5b5b",
}
